<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="formUnwatchable"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">

          <base-collapsible-form 
            ref="baseCollapsibleEmailsTo" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('app.list_emails_to')}}</h2>
                <!-- <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.client.contentTooltipWhiteList')" 
                  class="ml-2"/> -->
              </div>
            </template>
            <template slot="content">
              <el-table
              ref="listemailsto"
              :data="formUnwatchable.ListaTo"
              style="width: 100%"
              max-height="250"
              :show-header="false">
              <el-table-column
                prop="Nombre"
                label="Nombre"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="actions"
                width="80"
                align="center"
                label="-">
                <template slot-scope="scope">
                <div class="flex flex-row">
                  <base-button-icon v-if="EsPropietario" @click="deleteEmailLista(scope.row, 'to')" name="trash" mode="core" size="xs" ariaLabel="Eliminar email destinatario" />
                </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="w-full float-right">
              <base-button-responsive
                v-if="EsPropietario"
                mode="primary"
                :text="$t('clients.add_email')"
                @click="newEmailToToggleDialogTo()"
                icon="plus"
                class="m-5 float-right"
              />
            </div>
            </template>
          </base-collapsible-form>

          
          <base-collapsible-form 
            ref="baseCollapsibleEmailsCC" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('app.list_emails_cc')}}</h2>
                <!-- <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.client.contentTooltipWhiteList')" 
                  class="ml-2"/> -->
              </div>
            </template>
            <template slot="content">
              <el-table
              ref="listemailscc"
              :data="formUnwatchable.ListaCC"
              style="width: 100%"
              max-height="250"
              :show-header="false">
              <el-table-column
                prop="Nombre"
                label="Nombre"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="actions"
                width="80"
                align="center"
                label="-">
                <template slot-scope="scope">
                <div class="flex flex-row">
                  <base-button-icon v-if="EsPropietario" @click="deleteEmailLista(scope.row, 'cc')" name="trash" mode="core" size="xs" ariaLabel="Eliminar email en copia" />
                </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="w-full float-right">
              <base-button-responsive
                v-if="EsPropietario"
                mode="primary"
                :text="$t('clients.add_email')"
                @click="newEmailToToggleDialogCC()"
                icon="plus"
                class="m-5 float-right"
              />
            </div>
            </template>
          </base-collapsible-form>

          
          <base-collapsible-form 
            ref="baseCollapsibleEmailsCCO" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('app.list_emails_cco')}}</h2>
                <!-- <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.client.contentTooltipWhiteList')" 
                  class="ml-2"/> -->
              </div>
            </template>
            <template slot="content">
              <el-table
              ref="listemailscco"
              :data="formUnwatchable.ListaCCO"
              style="width: 100%"
              max-height="250"
              :show-header="false">
              <el-table-column
                prop="Nombre"
                label="Nombre"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="actions"
                width="80"
                align="center"
                label="-">
                <template slot-scope="scope">
                <div class="flex flex-row">
                  <base-button-icon v-if="EsPropietario" @click="deleteEmailLista(scope.row, 'cco')" name="trash" mode="core" size="xs" ariaLabel="Eliminar email en copia oculta" />
                </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="w-full float-right">
              <base-button-responsive
                v-if="EsPropietario"
                mode="primary"
                :text="$t('clients.add_email')"
                @click="newEmailToToggleDialogCCO()"
                icon="plus"
                class="m-5 float-right"
              />
            </div>
            </template>
          </base-collapsible-form>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <!-- <base-button-responsive 
            mode="primary" 
            :text="$t('app.save')" 
            icon="save" 
            @click="submitForm()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/> -->
        </template>
      </base-footer>
      <input-text-mail-from-white-list-simple-dialog 
        :dialogOpen="showModalNewMailTo"
        @toggleDialog="newEmailToToggleDialogTo"
        @applyDialog="applyNewMailDialogTo"
        header="Añadir nuevo email a la lista en 'Para'" 
        headerValue="Nuevo email" 
        :idNEO="id"
        />
      <input-text-mail-from-white-list-simple-dialog 
        :dialogOpen="showModalNewMailCC"
        @toggleDialog="newEmailToToggleDialogCC"
        @applyDialog="applyNewMailDialogCC"
        header="Añadir nuevo email a la lista en 'Copia'" 
        headerValue="Nuevo email" 
        :idNEO="id"
        />
      <input-text-mail-from-white-list-simple-dialog 
        :dialogOpen="showModalNewMailCCO"
        @toggleDialog="newEmailToToggleDialogCCO"
        @applyDialog="applyNewMailDialogCCO"
        header="Añadir nuevo email a la lista en 'Copia oculta'" 
        headerValue="Nuevo email" 
        :idNEO="id"
        />
      <link-my-groups-dialog 
        :dialogOpen="showModalLinkMyGroups" 
        @toggleDialog="linkMyGroupsToggleDialog" 
        @applyDialog="applyLinkMyGroupsDialog" 
        :idNEO="id"
        />
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import InputTextMailFromWhiteListSimpleDialog from '@/components/InputTextMailFromWhiteListSimpleDialog.vue'
import LinkMyGroupsDialog from '@/components/LinkMyGroupsDialog.vue'
import { getNotification } from '@/services/notifications/getNotification'
import { getEmailsNEO } from '@/services/notifications/getEmailsNEO'
import { newEmailNEO } from '@/services/notifications/newEmailNEO'
import { deleteEmailNEO } from '@/services/notifications/deleteEmailNEO'
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'emails-by-neo',
  components: {
    DetailLayoutFullWidth,
    InputTextMailFromWhiteListSimpleDialog,
    LinkMyGroupsDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('app.emails_link'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'notification/details'
      },
      auxGroupsMail: null,
      showModalLinkMyGroups: false,
      EsPropietario: false,
      showModalNewMailTo: false,
      showModalNewMailCC: false,
      showModalNewMailCCO: false,
      formUnwatchable: this.getDefaultFormUnwatchable(),
      notificationType: null,
      rules: {}
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return parseInt(this.$route.params.id)
    }
  },
  created: async function () {
    this.notificationType = this.$route.params.type !== null ? parseInt(this.$route.params.type) : null

    const breadcrumbs = []
    if (this.notificationType !== null && this.notificationType !== 99999) {
      breadcrumbs.push({ path: '' + this.notificationType, name: this.$i18n.t('app.notifications') })
    } else {
      breadcrumbs.push({ path: 'notifications', name: this.$i18n.t('app.notifications') })
    }
    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: this.truncate(breadcrumbHeader, 30, false) })
    } else {
      const notificationData = await this.downloadNotificationData(this.id)
      breadcrumbs.push({ path: '', name: this.truncate(notificationData.Asunto, 30, false) })
      this.$store.commit('app/setheaderBreadCrumb', notificationData.Asunto)
    }
    this.header.breadcrumb = breadcrumbs
    this.header.params = this.$route.params

    await this.downloadData()
  },
  mounted () {
    this.$refs.baseCollapsibleEmailsTo.toggle()
    this.$refs.baseCollapsibleEmailsCC.toggle()
    this.$refs.baseCollapsibleEmailsCCO.toggle()
    this.resetControlFormChanges()
  },
  methods: {
    linkMyGroupsToggleDialog () {
      this.showModalLinkMyGroups = !this.showModalLinkMyGroups
    },
    applyLinkMyGroupsDialog (grupos) {
      this.applyNewMailDialog(this.auxGroupsMail, grupos)
    },
    downloadNotificationData: async function (notificationId) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: notificationId
        }
        const notification = await getNotification(params)
        if (notification.blnError) {
          this.doFeedback(notification.msgError + ' [Código de error: ' + notification.codError + ']')
        }
        return notification.respuesta
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newEmailToToggleDialogTo () {
      this.showModalNewMailTo = !this.showModalNewMailTo
    },
    newEmailToToggleDialogCC () {
      this.showModalNewMailCC = !this.showModalNewMailCC
    },
    newEmailToToggleDialogCCO () {
      this.showModalNewMailCCO = !this.showModalNewMailCCO
    },
    applyNewMailDialogTo (form) {
      this.applyNewMailCommon(form, 'to')
    },
    applyNewMailDialogCC (form) {
      this.applyNewMailCommon(form, 'cc')
    },
    applyNewMailDialogCCO (form) {
      this.applyNewMailCommon(form, 'cco')
    },
    applyNewMailCommon (form, type) {
      this.auxGroupsMail = { type: type, ...form }
      if (form.GestionarListaBlancaGrupos) {
        this.linkMyGroupsToggleDialog()
      } else {
        this.applyNewMailDialog(this.auxGroupsMail)
      }
    },
    applyNewMailDialog: async function (emails, grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Email: emails.value, 
          idNEO: this.id,
          tipo: emails.type,
          idGrupos: grupos,
        }
        const response = await newEmailNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadData()
          this.showModalLinkMyGroups = false
          this.showModalNewMailTo = false
          this.showModalNewMailCC = false
          this.showModalNewMailCCO = false
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteEmailLista: async function (row, tipo) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Email: row.Nombre, 
          idNEO: this.id,
          tipo: tipo,
        }
        const response = await deleteEmailNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadData()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getDefaultFormUnwatchable () {
      return {
        ListaTo: [],
        ListaCC: [],
        ListaCCO: [],
      }
    },
    downloadData: async function () {
      try {
        const params = { idNEO: this.id }
        const result = await getEmailsNEO(params)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaTo = result.ListaTo?.map(x => ({ Nombre: x }))
          this.formUnwatchable.ListaCC = result.ListaCC?.map(x => ({ Nombre: x }))
          this.formUnwatchable.ListaCCO = result.ListaCCO?.map(x => ({ Nombre: x }))
          this.EsPropietario = result.EsPropietario
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
  }

}
</script>
